import axios from "axios";
import { DeleteCampaign } from "./creditBonusActions";
import { logActivity } from "../firebaseActions/activityLog";

export const cpCampaign = async (
  apiTag,
  data = {},
  docId,
  email,
  logMsg,
  onRollback,
) => {
  try {
    const response = await axios.post(
      "https://cp.gomarkets.com.au/makeRequest.php",
      {
        apiTag,
        ...data,
      },
    );
    return response.data;
  } catch (error) {
    //rollback Firestore entry if CP API call fails
    if (apiTag === "create_campaign") {
      await DeleteCampaign({
        campaignId: docId,
        email,
        logMsg: logMsg ? logMsg + docId : `cb_${apiTag.toLowerCase()}`,
        setIsLoading: () => {},
        setResponse: () => {},
      }).catch((e) => console.error("Rollback failed:", e));
    }

    if (apiTag === "update_campaign" && onRollback) {
      await onRollback().catch((e) => {
        console.error("Rollback failed:", e);
        logActivity({
          category: logMsg,
          event: logMsg ?? `cb_rollback_${apiTag}`,
          email,
          metadata: { campaignId: docId },
          message: "Rollback failed: " + e.message,
        });
      });

      logActivity({
        category: logMsg,
        event: logMsg ?? `cb_rollback_${apiTag}`,
        email,
        metadata: { campaignId: docId },
        message: "Rollback succeeded for: " + docId,
      });
    }

    if (apiTag === "delete_campaign") {
      logActivity({
        category: logMsg,
        event: logMsg ?? `cb_rollback_${apiTag}`,
        email,
        metadata: { campaignId: docId },
        message: "Delete failed for (cp): " + docId,
      });
    }

    throw new Error(
      `CP API ${apiTag} failed: ${error.response?.data?.message ?? error.message}`,
    );
  }
};
